module.exports = {
      id: "130f50d970fe6ac8155c741d28a0d31fstate-under-construction.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#130f50d970fe6ac8155c741d28a0d31fstate-under-construction.svg",
      toString: function () {
        return this.url;
      }
    }